import React from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import SheetTitle from '../../../components/SheetTitle';
import BackButton from '../../../components/BackButton';

import c from '../Help.less';

export default function MusicRequest() {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/music-request" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="I have a music request" />
      <p>
        If you are looking for some music we do not yet offer, please <Link to="/shop/music-request">send us a request</Link>{' '}
        and we will do our best to add it to our catalog.
      </p>
      <HelpContactUs subject={6} />
    </div>
  );
}
